"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactDom = require("react-dom");
var _subscribeEvent = _interopRequireDefault(require("subscribe-event"));
var _constants = require("../../api/constants");
var _index = _interopRequireDefault(require("../../api/index"));
var _whichTransitionEndEvent = _interopRequireDefault(require("../../utils/whichTransitionEndEvent"));
var _index2 = _interopRequireDefault(require("../Overlay/index"));
var _rprogressStyles = _interopRequireDefault(require("./rprogress-styles.less"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CYCLE_TYPE = 'cycle';
const CYCLE_PERCENTS = 25;
const TIMEOUT_DELAY_FOR_ANIMATIONS = 500;
const RProgress = _ref => {
  let {
    className,
    type,
    color
  } = _ref;
  const [progress, setProgress] = (0, _react.useState)(0);
  const [active, setActive] = (0, _react.useState)(false);
  const progressRef = (0, _react.useRef)();
  const node = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    node.current = document.createElement('div');
    document.body.appendChild(node.current);
    return () => {
      document.body.removeChild(node.current);
    };
  }, []);
  (0, _react.useEffect)(() => {
    _index.default.subscribe(event => {
      const {
        data
      } = event;
      let unsubscribe;
      let timeout;
      const hideProgress = () => {
        unsubscribe();
        clearTimeout(timeout);
        setProgress(0);
        setActive(false);
      };
      setProgress(data.position);
      setActive(true);
      if (data.type === _constants.PROGRESS_COMPLETE) {
        if (progressRef.current && type !== CYCLE_TYPE) {
          unsubscribe = (0, _subscribeEvent.default)(progressRef.current, _whichTransitionEndEvent.default, hideProgress);
          // Run timeout in case transitionEndEvent failed for some reasons
          timeout = setTimeout(hideProgress, TIMEOUT_DELAY_FOR_ANIMATIONS);
        } else {
          setProgress(0);
          setActive(false);
        }
      }
    });
  }, [type]);
  if (!progress && !node.current) {
    return null;
  }
  let percents = progress;
  let cycleClass;
  if (type === CYCLE_TYPE) {
    percents = CYCLE_PERCENTS;
    cycleClass = 'rprogress_cycle';
  }
  const stylesObj = {
    width: `${percents}%`
  };
  if (color) {
    stylesObj.backgroundColor = color;
  }
  const classes = `${_rprogressStyles.default.rprogress || 'rprogress'} ${cycleClass ? _rprogressStyles.default[cycleClass] || cycleClass : ''} ${className || ''}`;
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.default, {
    visible: active,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes,
      style: stylesObj,
      ref: progressRef,
      children: ' '
    })
  }), node.current);
};
var _default = exports.default = RProgress;
//# sourceMappingURL=index.js.map